angular.module("AccountingBoxApp").config(function($stateProvider) {
  $stateProvider
    .state("app.company.edit", {
      // url: '/edit',
      abstract: true,
      //template: '<ui-view/>',
      templateUrl: "app/transaction/transaction.html",
      controller: "TransactionCtrl",
      controllerAs: "tra"
    })
    .state("app.company.new", {
      abstract: true,
      templateUrl: "app/transaction/transaction.html",
      controller: "TransactionCtrl",
      controllerAs: "tra",
      params: {
        attachment: null
      }
    });
});
